import { Box, CircularProgress } from '@mui/material';
import Image from 'next/image';
import { Images } from '@/assets/images';

const KinetekLoader: React.FC = () => {
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="rgba(0, 0, 0, 0.5)"
      zIndex={1300}
    >
      <Box position="relative" width={120} height={120} display="flex" alignItems="center" justifyContent="center">
        <CircularProgress size={120} color="primary" thickness={4} />
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Image src={Images.KINETEK_LOGO} alt="logo" height={64} width={64} />
        </Box>
      </Box>
    </Box>
  );
};

export default KinetekLoader;
